/**
 * Generic api export which set environment using process.env.REACT_APP_ENV
 */

/* eslint-disable global-require, import/no-dynamic-require */
export const {
  API_BASE_URL,
  APP_URL,
  AUTHENTICATION_URL,
  ID_CATEGORIA_ENVIO,
} = require(`./${process.env.REACT_APP_ENV}/api`)
